import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpHeaders } from '@angular/common/http';

import { BehaviorSubject, map, Observable } from 'rxjs';

import { AccountClient, CerIdentityUserDto, FileResponse } from 'src/app/api';
import { CerSessionService } from '@cer/cer-session/cer-session.service';
import { CerSessionEnvironmentService } from '@cer/cer-session/cer-session-environment.service';


@Injectable({
  providedIn: 'root'
})
export class CerAuthorizeService {
  public user$: BehaviorSubject<CerIdentityUserDto> = new BehaviorSubject<CerIdentityUserDto>(null);
  public userKey: string;

  //public userKey: string;
  private static loginRoute : string = 'identity/' + 'account/login'; 
  private static logoutRoute : string = 'identity/' + 'account/logout'; 

  constructor(private client: AccountClient, private session: CerSessionService,
     private sessionEnvironment: CerSessionEnvironmentService, private router: Router) {
  }

  public loginUrl() : string {
    return this.sessionEnvironment.baseUrl + CerAuthorizeService.loginRoute;
  } 

  public navigateToLogout() {
    window.location.replace(CerAuthorizeService.logoutRoute);
  }

  public navigateToLogin(returnUrl: string = null) : Promise<boolean> {
    const url = this.loginUrl() + (returnUrl?.length > 0 ? "?returnUrl="+returnUrl : "");
    window.location.replace(url);
    let p = new Promise<boolean>(resolve => { return true; });
    return p;
    /*
    if (returnUrl?.length > 0 ) {
      return this.router.navigate([CerAuthorizationService.loginRoute], {queryParams: {returnUrl: returnUrl}});
    }
    else {
      return this.router.navigateByUrl(CerAuthorizationService.loginRoute);
    }*/
  }

  public navigateToHome() {
    this.router.navigateByUrl('/');
  }

  public navigateToResendEmailConfirmationLink() {
    this.router.navigateByUrl('/account/send-email/resend-email-confirmation-link');
  }
  
  public refreshUser(jwt: string | null): void {
    if (jwt === null) {
      if (this.user$ != null) {
        this.user$.next(null);
      }
      return; // this.user$;
    }

    let headers = new HttpHeaders();
    headers = headers.set('Authorization', 'Bearer ' + jwt);

    this.client.refreshUserToken().subscribe(
      user => {
        //this.setUser(user);
      });
  }

  public login(userName: string, password: string): Observable<CerIdentityUserDto> {
    return this.client.login(userName, password).pipe(
      map(user => {
        //this.setUser(user);
        return user;
      })
    );
  }

  public loginWithThirdParty(accessToken: string, userId: string, provider: string) : Observable<CerIdentityUserDto> {
    return this.client.loginWithThirdParty(accessToken, userId, provider).pipe(
      map(user => {
        this.setUser(user);
        return user;
      })
    );
  }

  public logout() : void {
    //localStorage.removeItem(this.userKey);
    this.user$.next(null);
    this.navigateToHome();
  }

  public register(firstName: string, lastName: string, email: string, password: string): Observable<FileResponse> {
    return this.client.register(firstName, lastName, email, password);
  }

  public registerWithThirdParty(accessToken: string, userId: string, provider: string): Observable<CerIdentityUserDto> {
    return this.client.registerWithThirdParty(accessToken, userId, provider).pipe(
      map(user => {
        this.setUser(user);
        return user;
      })
    );
  }

  public confirmEmail(confirmToken: string, email: string) : Observable<FileResponse> {
    return this.client.confirmEmail(confirmToken, email);
  }

  public resendEmailConfirmationLink(email: string): Observable<FileResponse> {
    return this.client.resendEMailConfirmationLink(email);
  }

  public forgotUsernameOrPassword(email: string): Observable<FileResponse> {
    return this.client.forgotUsernameOrPassword(email);
  }

  public resetPassword(token: string, email: string, newPassword: string): Observable<FileResponse> {
    return this.client.resetPassword(token, email, newPassword);
  }

  private getJWT() : string {
    const key = sessionStorage.getItem(this.userKey);
    if (key) {
      const user: CerIdentityUserDto = JSON.parse(key);
      return user.jwt;
    } else {
      return null;
    }
  }

  private setUser(user: CerIdentityUserDto) : void{
    sessionStorage.setItem(this.userKey, JSON.stringify(user));
    this.user$.next(user);
  }

  public showNotification(isSuccess: boolean, title: string, message: string) : void {
    console.log(message);
  }
}
